// main.ts
import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import * as Sentry from '@sentry/angular';
import {replayIntegration} from '@sentry/angular'; // vem do angular v10
import {browserTracingIntegration} from '@sentry/angular'; // pra tracing

import packageInfo from '../package.json';
import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
if (environment.production) {
  enableProdMode();
}

console.log(
  `%c 🚀 GEIA ERP %c v${packageInfo.version} %c [Ambiente: ${environment.environmentName.toUpperCase()}] %c API: ${environment.apiBaseUrl} `,
  'background: #007bff; color: white; font-weight: bold; border-radius: 3px 0 0 3px; padding: 2px 6px;',
  'background: #6c757d; color: white; font-weight: bold; padding: 2px 6px;',
  'background: #28a745; color: white; font-weight: bold; padding: 2px 6px;',
  'background: #212529; color: #17a2b8; border-radius: 0 3px 3px 0; padding: 2px 6px;',
);

const isLocalhost =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname === '::1');

const traceTargets = environment.sentryTracingOrigins.map(origin =>
  typeof origin === 'string'
    ? new RegExp(origin.replace(/\./g, '\\.'))
    : origin,
);

Sentry.init({
  enabled: !isLocalhost,
  dsn: environment.sentryDsn,
  release: `erpgeia@${packageInfo.version}`,

  environment: environment.environmentName,
  integrations: [
    new Sentry.BrowserTracing({
      tracePropagationTargets: traceTargets,
    }),
    new Sentry.Replay(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.5,
  replaysOnErrorSampleRate: 1.0,
  allowUrls: traceTargets,
});

// Inicializa o app Angular normalmente
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
